import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SettingsState {
  currencySymbol: string;
  setCurrencySymbol: (symbol: string) => void;
  defaultUnit: string;
  setDefaultUnit: (unit: string) => void;
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      currencySymbol: 'Rp.',
      setCurrencySymbol: (symbol) => set({ currencySymbol: symbol }),
      defaultUnit: 'pcs',
      setDefaultUnit: (unit) => set({ defaultUnit: unit }),
    }),
    {
      name: 'settings-storage',
    }
  )
);
